import type { SVGProps } from 'react';

const SvgText = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="text">
      <path d="M.48 29a2.71 2.71 0 0 0 2.7 2.71h25.64a2.71 2.71 0 0 0 2.7-2.71V3a2.71 2.71 0 0 0-2.7-2.68H3.18A2.71 2.71 0 0 0 .48 3ZM2 3a1.21 1.21 0 0 1 1.2-1.21h25.62A1.21 1.21 0 0 1 30 3v26a1.21 1.21 0 0 1-1.2 1.21H3.18A1.21 1.21 0 0 1 2 29Z" />
      <path d="M8.75 10.23a.93.93 0 0 1 .92-.93h5.58v13.4h-2.72v1.5h6.87v-1.5h-2.65V9.3h5.58a.93.93 0 0 1 .92.93v2.39h1.5v-2.39a2.42 2.42 0 0 0-2.42-2.43H9.67a2.42 2.42 0 0 0-2.42 2.43v2.39h1.5Z" />
    </g>
  </svg>
);

export default SvgText;
